import React, {FC} from "react"

import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import {Tag} from "@irati/types"
import {H2, Body} from "@irati/ui/src/Typography"
import {Strong} from "@irati/ui/src/Labels"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"

import {StyledModal} from "./styled"

interface Props extends InjectIntl {
  unavailableCategories: Tag[],
  hideModal: () => void,
  navigateToCategories?: () => void,
  showCustomisationLink?: boolean
}

const UnavailableCategoryModal: FC<Props> = ({
  formatMessage,
  unavailableCategories,
  hideModal,
  navigateToCategories,
  showCustomisationLink
}) => {
  const unavailableCategoriesCount = unavailableCategories.length
  return (
    <StyledModal
      show
      onHide={hideModal}
      image={formatMessage({id: "platform.customisation.unavailableCategory.modalImage"})}
      actions={
        <Flex justifyContent="flex-end" alignItems="center" marginTop={3}>
          {showCustomisationLink && (
            <Button marginRight={2} secondary onClick={navigateToCategories}>
              <FormattedMessage id="platform.customisation.unavailableCategory.buttonText2" />
            </Button>
          )}
          <Button primary onClick={hideModal}>
            <FormattedMessage id="platform.customisation.unavailableCategory.buttonText1" />
          </Button>
        </Flex>
      }>
      <H2>
        <FormattedMessage id="platform.customisation.unavailableCategory.modalHeader" />
      </H2>
      <Body marginTop={2}>
        <FormattedMessage id="platform.customisation.unavailableCategory.modalText1" />
        {unavailableCategories.map(({name}, index) => (
          <>
            {unavailableCategoriesCount > 1 &&
              index === unavailableCategoriesCount - 1 &&
              ` ${formatMessage({id: "platform.customisation.unavailableCategory.linkText"})} `}
            <Strong>&quot;{name}&quot;</Strong>
            {unavailableCategoriesCount > 1 && index < unavailableCategoriesCount - 1 && ", "}
          </>
        ))}
        <FormattedMessage
          id="platform.customisation.unavailableCategory.modalText2"
          values={{
            categories: unavailableCategories.length
          }} />
      </Body>
    </StyledModal>
  )
}

export default injectIntl(UnavailableCategoryModal)
